import { Button, Tag } from '@ads/components-react';
import { useTranslation } from 'react-i18next';
import type { ExamItemLangGridItemViewModel } from '@/shared/api/generated/types/ExamItemLangGridItemViewModel';

export interface QuestionCardProps {
  readonly question: ExamItemLangGridItemViewModel;
  readonly onEdit?: (id: number) => void;
}

export function QuestionCard({ question, onEdit }: QuestionCardProps) {
  const { t } = useTranslation('examManagement');

  return (
    <div className="flex items-center justify-between rounded-sm border-hairline border-ctx-layout-border bg-ctx-layout-surface py-xxxs px-xs">
      <div className="flex flex-1 flex-col gap-nano">
        <span
          className="ts-paragraph-xs text-ctx-content-base line-clamp-2"
          dangerouslySetInnerHTML={{
            __html: question.labelClean ?? question.label ?? '',
          }}
        />

        <div className="flex items-center gap-mini">
          {question.componentType && (
            <span className="ts-subtitle-xxs text-ctx-content-base">{question.componentType}</span>
          )}
          {question.disciplineName && (
            <span className="ts-subtitle-xxs text-ctx-content-placeholder">
              {question.disciplineName}
            </span>
          )}
          {question.cancelled && (
            <Tag
              label={t('status.inactive')}
              size="sm"
              status="negative"
              custom={{ text: 'text-nowrap' }}
            />
          )}
          {question.active === false && !question.cancelled && (
            <Tag
              label={t('status.inactive')}
              size="sm"
              status="default"
              custom={{ text: 'text-nowrap' }}
            />
          )}
        </div>
      </div>
      {onEdit && (
        <Button hierarchy="secondary" size="md" onClick={() => onEdit(question.id ?? 0)}>
          {t('actions.edit')}
        </Button>
      )}
    </div>
  );
}
